import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';

export const templatePhasrMonitoredRules = document.createElement('template');

templatePhasrMonitoredRules.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='loading-container'>
        <gz-progress-spinner></gz-progress-spinner>
    </div>
    <gz-phasr-monitored-rules-grid></gz-phasr-monitored-rules-grid>
  </div>
`;